import { Placeholder } from "@aws-amplify/ui-react"
import { ScreeningAnswer } from "@prisma/client"
import { Tag } from "components/common/Tag"
import { ClockIcon } from "components/icons"
import { TypographyV2 } from "components/v2"
import { classNames } from "utils"
const MinutesQuestionResponse = ({
    question,
    screeningAnswer,
    sybQuestion = false,
    isLastQuestion = false,
    placeholder = "-"
}: {
    question: any
    screeningAnswer: ScreeningAnswer
    sybQuestion?: boolean
    isLastQuestion?: boolean
    placeholder?: string
}) => {
    const responseTagClassNames = "items-center gap-2 h-fit w-fit -translate-x-1 -translate-y-1.5"

    function formatDuration(minutes: number) {
        if (minutes == null || isNaN(minutes)) return "N/A"

        const days = Math.floor(minutes / (60 * 24))
        const hours = Math.floor((minutes % (60 * 24)) / 60)
        const mins = minutes % 60

        const parts = []
        if (days > 0) parts.push(`${days} Day${days > 1 ? "s" : ""}, `)
        if (hours > 0) parts.push(`${hours} Hour${hours > 1 ? "s" : ""}, `)
        if (mins > 0 || parts.length === 0) parts.push(`${mins} Minute${mins > 1 ? "s" : ""}`)

        return parts.join(" ")
    }

    return (
        <div
            className={classNames(
                "bg-white border-slate-300 py-4 px-3",
                sybQuestion ? "border-b" : "border rounded-lg",
                !isLastQuestion && "border-none"
            )}
        >
            <TypographyV2 type="sm" className="font-bold">
                {question.question}
            </TypographyV2>
            <TypographyV2 className="text-[#6B7280] mt-2" type="base">
                <Tag color="gray" className={classNames(responseTagClassNames, "!text-dark-blue")}>
                    <ClockIcon className="w-5" />{" "}
                    {screeningAnswer?.value ? formatDuration(+screeningAnswer.value) : placeholder}
                </Tag>
            </TypographyV2>
        </div>
    )
}

export default MinutesQuestionResponse
